import { createRouter, createWebHistory } from "vue-router";
import Subscriber from "../components/SubscriberPdfForm.vue";
import PDFDownloadPage from "../components/PDFDownload.vue";
import PDFInvoiceDownloadPage from "../components/PDFInvoiceDownload.vue";
import InvalidRequest from "../components/InvalidRequest.vue";
import { useStore } from "vuex";
import OtpGenerate from "@/components/OtpGenerate.vue";
import OtpValidate from "@/components/OtpValidate.vue";
import HomePage from "@/components/HomePage.vue";

const routes = [
  { path: "/", component: HomePage, name: "HomePage" },
  { path: "/subscriber", component: Subscriber, name: "Subscriber" },
  { path: "/download", component: PDFDownloadPage, name: "PDFDownloadPage" },
  { path: "/invoice-download", component: PDFInvoiceDownloadPage, name: "PDFInvoiceDownloadPage" },

  {
    path: "/invalid-request",
    component: InvalidRequest,
    name: "InvalidRequest",
  },
  {
    path: "/:pathMatch(.*)*",
    component: InvalidRequest,
    name: "InvalidRequest",
  },
  {
     path: "/generate", component: OtpGenerate, name: "OtpGenerate" 
  },
  {
     path: "/validate", component: OtpValidate, name: "OtpValidate" 
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useStore();
  // List of routes that require authentication
  const protectedRoutes = ["PDFDownloadPage", "OtpGenerate", "OtpValidate"];

  // If the target route is protected but user is not authenticated
  if (to.name=="PDFDownloadPage" && !store.state.isAuth) {
    next({ name: "InvalidRequest" });
  } 
  else if (to.name=="PDFInvoiceDownloadPage" && !store.state.isAuth) {
    next({ name: "InvalidRequest" });
  } 
  else if(to.name=="OtpGenerate" && !store.state.isOtpGenerateAuth) {
    next({ name: "InvalidRequest" });
  }else if(to.name=="OtpValidate" && !store.state.isOtpValidateAuth){
    next({ name: "InvalidRequest" });
  }
  else{
    next();
  }
});

export default router;
